import { render } from "./TemplateTimetable.vue?vue&type=template&id=972a06d6&scoped=true"
import script from "./TemplateTimetable.vue?vue&type=script&lang=js"
export * from "./TemplateTimetable.vue?vue&type=script&lang=js"

import "./TemplateTimetable.vue?vue&type=style&index=0&id=972a06d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972a06d6"]])

export default __exports__